import axios from 'axios';
import type {
  IUserSearchForMLSStaffQuery,
  IUserSearchForMLSStaffRequest,
  IUserSearchForMLSStaffResponse,
} from '@/app-package';

const searchForMLSStaff = async (params: IUserSearchForMLSStaffQuery) => {
  const config: IUserSearchForMLSStaffRequest = {
    url: '/user/search/mls_staff',
    method: 'get',
    params,
  };

  const { data } = await axios.request<IUserSearchForMLSStaffResponse>(config);

  return data;
};

export default searchForMLSStaff;
